import React from 'react'

const SuccessMessagePage = () => {
  return (
    <>
      <h1>Already responded</h1>
    </>
  )
}

export default SuccessMessagePage
